<template lang="html">
  <booking-layouts
    v-bind="$attrs"
  >

    <template v-slot:grid="slotProps">
      <layout-grid
        v-bind="slotProps"
        @gridWheel="slotProps.onGridWheel"
        @wallMousedown="slotProps.onWallMousedown"
        @wallDelete="slotProps.onWallDelete"
        @resourceMousedown="slotProps.onResourceMousedown"
        @resourceDelete="slotProps.onResourceDelete"
        @resourceRotate="slotProps.onResourceRotate"
      ></layout-grid>
    </template>

  </booking-layouts>
</template>

<script>
import {BookingLayouts} from 'dync-booking'
import LayoutGrid from './LayoutGrid.vue';

export default {
  inheritAttrs: false,
  data() {
    return {};
  },
  components: {
    BookingLayouts,
    LayoutGrid
  }
}
</script>

<style lang="scss" scoped>
</style>
